var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-layout", { attrs: { row: "", wrap: "" } }, [
    _vm.item.isSuccess
      ? _c(
          "div",
          { staticStyle: { flex: "1 0" } },
          [
            _c(
              "v-card-title",
              { staticClass: "card-bg-2 font-weight-medium py-1" },
              [_vm._v("\n      The test run has found:\n    ")]
            ),
            _vm._v(" "),
            _c(
              "v-card-text",
              { staticClass: "py-2" },
              _vm._l(_vm.serviceKeys, function (dataKey, i) {
                return _c(
                  "div",
                  { key: i },
                  [
                    _c("v-icon", { staticClass: "no-transition mr-1" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            dataKey.icon
                              ? dataKey.icon
                              : _vm.getMediaTypeIcon(_vm.item.media_type)
                          ) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.item[dataKey.key]) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { class: { "grey--text text--darken-1": !_vm.hover } },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.pluralize(
                                dataKey.displayName,
                                _vm.item[dataKey.key]
                              )
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ],
                  1
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("v-card-title", { staticClass: "card-bg-2 py-1" }, [
              _vm._v(
                "\n      If the data does not match, review the file or update the importer configuration.\n    "
              ),
            ]),
          ],
          1
        )
      : _c("div", { staticStyle: { flex: "1 0" } }, [
          _vm._v(
            "\n    Test run failed. Review the file or view the logs for details.\n  "
          ),
        ]),
    _vm._v(" "),
    _c("div", [
      _vm.item.fileName
        ? _c(
            "div",
            { staticClass: "text-xs-right" },
            [
              _c(
                "v-tooltip",
                {
                  attrs: { bottom: "", "open-delay": 300 },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on }) {
                          return [
                            _c(
                              "v-chip",
                              _vm._g({ attrs: { small: "", label: "" } }, on),
                              [
                                _c("v-icon", { staticClass: "mr-2" }, [
                                  _vm._v("attach_file"),
                                ]),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.item.fileName) +
                                    "\n          "
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    762968739
                  ),
                },
                [_vm._v(" "), _c("span", [_vm._v(" File name ")])]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.item.cocCodes
        ? _c(
            "div",
            { staticClass: "text-xs-right" },
            [
              _c(
                "v-tooltip",
                {
                  attrs: { bottom: "", "open-delay": 300 },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on }) {
                          return [
                            _c(
                              "v-chip",
                              _vm._g({ attrs: { small: "", label: "" } }, on),
                              [
                                _c("v-icon", { staticClass: "mr-2" }, [
                                  _vm._v("link"),
                                ]),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.item.cocCodes) +
                                    "\n          "
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1986573057
                  ),
                },
                [_vm._v(" "), _c("span", [_vm._v(" COC Code ")])]
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }